import axios from './../../config/axios';

function create(data) {
    return axios().post("/sales/branches", data, {
        headers: {
            Dpk: data.dpk
        }
    });
}

function get(id) {
    return axios().get(`/sales/branches/${id}`);
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    return axios().get(`/sales/branches`, {
        params
    })
}

function update(id, data) {
    return axios().put(`/sales/branches/${id}`, data)
}

function destroy(id) {
    return axios().delete(`/sales/branches/${id}`);
}

function search(query) {
    return axios().get("/sales/branches-search", {
        params: {
            search: query
        }
    })
}

export default {
    create,
    get,
    index,
    update,
    destroy,
    search
}